<template>
    <div>
        <div class="mb-2">
            <v-btn @click="$router.push({name:'usersList'})" text>Retour</v-btn>
        </div>
        <v-card :loading="loading.user" elevation="0">
            <v-snackbar :timeout="2000" color="success" top v-model="success.submitting">Modifications enregistrées
                <v-icon dark>mdi-check-circle</v-icon>
            </v-snackbar>
            <v-snackbar :timeout="2000" color="success" top v-model="success.deletingAll">Autorisations supprimées
                <v-icon dark>mdi-check-circle</v-icon>
            </v-snackbar>

            <v-snackbar color="error" top v-model="error.invalidGrants">La valeur de "grants" n'est un JSON correct
                <v-icon dark>warning</v-icon>
            </v-snackbar>
            <div v-if="!loading.user">
                <v-card-title>{{user.fullName}}</v-card-title>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="4" sm="6">
                            <v-list elevation="2">
                                <v-subheader>Services
                                    <v-spacer/>
                                    <v-btn :disabled="!Number.isInteger(selectedServiceIdx)"
                                           :loading="loading.deletingAll" @click="deleteAllAuthorForServiceClicked"
                                           color="error" icon outlined x-small>
                                        <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn @click="addingAuthorization=true" class="ml-2" color="primary" icon outlined
                                           x-small>
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-subheader>
                                <v-list-item-group v-model="selectedServiceIdx">
                                    <v-list-item :key="i" v-for="(s,i) in services">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="s"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                            <v-list elevation="2">
                                <v-subheader>Scopes
                                    <v-spacer/>
                                    <v-btn :disabled="!Number.isInteger(selectedScopeIdx)"
                                           @click="duplicateSelectedScopedAuthor"
                                           color="secondary" icon x-small>
                                        <v-icon>file_copy</v-icon>
                                    </v-btn>
                                    <v-btn :disabled="!Number.isInteger(selectedScopeIdx)"
                                           :loading="loading.deletingSingle"
                                           @click="deleteAuthorForScopeClicked"
                                           class="ml-4"
                                           color="error" icon outlined x-small>
                                        <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn @click="addingAuthorization=true" class="ml-2" color="primary" icon outlined
                                           x-small>
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-subheader>
                                <v-list-item-group v-model="selectedScopeIdx">
                                    <v-list-item v-for="(as,i) in authorizationsForService">
                                        <v-list-item-content :key="i">
                                            <v-list-item-title><span
                                                    v-if="as.scope.companyUuid && as.scope.companyUuid !== ''">Société <pre>{{as.scope.companyUuid}}</pre></span><span
                                                    v-else>Toutes les sociétés</span></v-list-item-title>
                                            <v-list-item-title><span
                                                    v-if="as.scope.branchUuid && as.scope.branchUuid !== ''">Agence <pre>{{as.scope.branchUuid}}</pre></span><span
                                                    v-else>Toutes les agences</span></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                                <v-subheader v-if="authorizationsForService.length===0">Sélectionnez un service
                                </v-subheader>
                            </v-list>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card :loading="loading.submit">
                                <v-subheader class="pt-8 pb-4">Authorizations</v-subheader>
                                <v-form @submit.prevent="saveAuthorization" v-if="Number.isInteger(selectedScopeIdx)">
                                    <user-authorization-form :service="selectedService"
                                                             v-model="selectedAuthorizationEditable"/>
                                    <v-card-actions>
                                        <v-btn @click="prepareEditableAuthor" color="secondary" text>Annuler</v-btn>
                                        <v-spacer/>
                                        <v-btn :loading="loading.submit" color="primary" text type="submit">Sauvegarder
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                                <v-card-text class="pb-6" v-else>Sélectionnez un scope</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <v-dialog v-model="addingAuthorization" width="500">
                <add-user-authorization-form
                        :prefilled-authorization-form="prefilledAuthorizationForm"
                        :preselected-service-name="selectedServiceName"
                        :services-list="allServicesList"
                        :user="user" @cancel="addingAuthorization=false"
                        @save="newAuthorSaved"
                        ref="addAuthorForm"/>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
	import UserAuthorizationForm from "../../components/UserAuthorizationForm";
	import AddUserAuthorizationForm from "../../components/AddUserAuthorizationForm";
	import {mapActions, mapState} from 'vuex'

	export default {
		name: "UserDetailView",
		components: {AddUserAuthorizationForm, UserAuthorizationForm},
		data() {
			return {
				user: {},
				selectedServiceIdx: null,
				selectedScopeIdx: null,
				selectedAuthorizationEditable: null,
				prefilledAuthorizationForm: {scope: {}, authorization: {}},
				addingAuthorization: false,
				loading: {
					user: false,
					submit: false,
					deletingSingle: false,
					deletingAll: false,
				},
				error: {
					loading: false,
					submitting: false,
					invalidGrants: false,
					deletingSingle: false,
					deletingAll: false,
				},
				success: {
					submitting: false,
					deletingSingle: false,
					deletingAll: false,
				}
			}
		},
		watch: {
			selectedServiceIdx(newVal) {
				this.selectedScopeIdx = null;
			},
			selectedScopeIdx(newVal) {
				if (Number.isInteger(newVal)) this.prepareEditableAuthor();
			}
		},
		computed: {
			...mapState('services', {
				allServicesList: (state) => state.services
			}),
			services() {
				return (this.user && this.user.authorizations) ? Object.keys(this.user.authorizations) : [];
			},
			selectedService() {
				let r = null;
				for (let s of this.allServicesList) {
					if (s.serviceName === this.selectedServiceName)
						r = s;
				}
				return r;
			},
			selectedServiceName() {
				return Number.isInteger(this.selectedServiceIdx) ? this.services[this.selectedServiceIdx] : null;
			},
			authorizationsForService() {
				return Number.isInteger(this.selectedServiceIdx) ? (this.user.authorizations[this.services[this.selectedServiceIdx]]) : [];
			},
			authorizationForScope() {
				return Number.isInteger(this.selectedScopeIdx) ? (this.user.authorizations[this.services[this.selectedServiceIdx]][this.selectedScopeIdx].authorization) : {};
			},
			selectedScope() {
				return Number.isInteger(this.selectedScopeIdx) ? (this.user.authorizations[this.services[this.selectedServiceIdx]][this.selectedScopeIdx].scope) : {};
			}
		},
		mounted() {
			this.fetch(this.$route.params.userId);
			this.fetchServices();
		},
		methods: {
			...mapActions('services', ['fetchServices']),
			fetch(userId) {
				this.loading.user = true;
				this.error.loading = false;
				this.$http.get(this.$config.apiUrl + "/v2/users/" + userId)
					.then((r) => this.user = r.data)
					.catch(() => this.error.loading = true)
					.finally(() => this.loading.user = false);
			},
			prepareEditableAuthor() {
				this.selectedAuthorizationEditable = {
					role: this.authorizationForScope.role,
					grants: this.authorizationForScope.grants ? JSON.stringify(this.authorizationForScope.grants) : ""
				}
			},
			saveAuthorization() {
				try {
					this.error.invalidGrants = false;
					this.error.submitting = false;
					let author = {
						role: this.selectedAuthorizationEditable.role,
						grants: JSON.parse(this.selectedAuthorizationEditable.grants)
					}
					this.user.authorizations[this.selectedServiceName][this.selectedScopeIdx].authorization = author;
					this.loading.submit = true;
					this.$http.put(this.$config.apiUrl + "/v2/users/" + this.user.id + "/services/" + this.selectedServiceName + "/authorizations", this.user.authorizations[this.selectedServiceName])
						.then(r => this.success.submitting = true)
						.catch(e => this.error.submitting = true)
						.finally(() => this.loading.submit = false)

				} catch (e) {
					this.error.invalidGrants = true;
				}
			},
			newAuthorSaved() {
				this.addingAuthorization = false;
				this.fetch(this.user.id);
			},
			duplicateSelectedScopedAuthor() {
				this.addingAuthorization = true;
				this.$nextTick(() => {
					this.prefilledAuthorizationForm.scope = this.selectedScope;
					this.prefilledAuthorizationForm.authorization = {
						role: this.authorizationForScope.role,
						grants: this.authorizationForScope.grants ? JSON.stringify(this.authorizationForScope.grants) : ""
					}
				});
			},
			deleteAllAuthorForServiceClicked() {
				this.error.deletingAll = false;
				this.loading.deletingAll = true;
				this.$http.delete(this.$config.apiUrl + "/v2/users/" + this.user.id + "/services/" + this.selectedServiceName + "/authorizations")
					.then(r => {
						this.selectedServiceIdx = null;
						this.success.deletingAll = true
						this.fetch(this.user.id);
					})
					.catch(e => this.error.deletingAll = true)
					.finally(() => this.loading.deletingAll = false)
			}
			,
			deleteAuthorForScopeClicked() {
				this.error.deletingSingle = false;
				this.loading.deletingSingle = true;
				if (this.authorizationsForService.length === 1) {
					this.$http.delete(this.$config.apiUrl + "/v2/users/" + this.user.id + "/services/" + this.selectedServiceName + "/authorizations")
						.then(r => {
							this.selectedServiceIdx = null;
							this.success.deletingSingle = true
							this.fetch(this.user.id);
						})
						.catch(e => this.error.deletingSingle = true)
						.finally(() => this.loading.deletingSingle = false)
				} else {
					let toRemoveIdx = this.selectedScopeIdx;
					let authorizationsToKeep = this.authorizationsForService.filter((s, i) => i !== toRemoveIdx); // Filtre sur l'index, on ne veut pas le scope sélectionné
					this.$http.put(this.$config.apiUrl + "/v2/users/" + this.user.id + "/services/" + this.selectedServiceName + "/authorizations", authorizationsToKeep)
						.then(r => {
							this.success.deletingSingle = true
							this.fetch(this.user.id);
						})
						.catch(e => this.error.deletingSingle = true)
						.finally(() => this.loading.deletingSingle = false)
				}
			}
		}
	}
</script>

<style scoped>

</style>
